<template>
    <div class="page_body">
        <div class="data_main">
            <div class="data_group" v-if="power.indexOf('1')>=0">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="openAdd">新增</el-button>
            </div>
            <div class="data_table mt18">
                <el-table :data="listData" style="width: 100%" v-loading="isRequestLoading">
                    <el-table-column prop="roleName" label="角色名称" min-width="100px" align="center"></el-table-column>
                    <el-table-column prop="address" label="操作" align="center" v-if="power.indexOf('2')>=0 || power.indexOf('3')>=0">
                        <template slot-scope="scope">
                            <el-button type="text" @click="openEdit(scope.row)" v-if="power.indexOf('2')>=0">编辑</el-button>
                            <el-button type="text" @click="delSysRole(scope.row.id)" v-if="power.indexOf('3')>=0">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <el-dialog class="popup_dialog" title="新增角色" :visible.sync="role" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="600px">
              <el-form ref="formRole" :rules="rules" size="small" label-position='top'>
                <el-form-item label="角色名称：" prop="roleName">
                  <el-input v-model="formRole.roleName" placeholder="请输入角色名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <div class="vertical">
                    <div class="mr100">
                      <div class="title">
                        模块
                      </div>
                      <div class="body">
                        <el-checkbox-group v-model="powerFatherChoose" class="elgroup">
                          <el-checkbox v-for="(item, index) in powerFatherList" :key="index+'a'" :label="item.id" :alt="item.name" @change="changePower(item.id,index)"><div @click.prevent="toChangePFCheck(index)">{{item.name}}</div></el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div>
                      <div class="title">
                        权限
                      </div>
                      <div class="body">
                        <div v-if="powerChlidList[powerChildChooseShow].length==0"></div>
                        <div v-else-if="powerChlidList[powerChildChooseShow][0].child" style="display:flex">
                          <div v-for="(item, index) in powerChlidList[powerChildChooseShow]" :key="index+'b'" class="mr40">
                            <div>{{ item.name }}</div>
                            <el-checkbox :indeterminate="isIndeterminate[powerChildChooseShow][index]" v-model="checkAll[powerChildChooseShow][index]" @change="handleCheckAllChange(index)">全选</el-checkbox>
                            <el-checkbox-group v-model="powerChildChoose[powerChildChooseShow][index]" class="elgroup" @change="handleCheckedCitiesChange(index)">
                              <el-checkbox v-for="(items, indexs) in item.child" :key="indexs+'c'" :label="items.id" :alt="items.name" @change="handleCheckedChange(index,indexs,$event)"><span>{{items.name}}</span></el-checkbox>
                            </el-checkbox-group>
                          </div>
                        </div>
                        <div v-else>
                          <el-checkbox :indeterminate="isIndeterminate[powerChildChooseShow]" v-model="checkAll[powerChildChooseShow]" @change="handleCheckAllChange(999)">全选</el-checkbox>
                          <el-checkbox-group v-model="powerChildChoose[powerChildChooseShow]" class="elgroup" @change="handleCheckedCitiesChange(999)">
                            <el-checkbox v-for="(item, index) in powerChlidList[powerChildChooseShow]" :key="index+'d'" :label="item.id" :alt="item.name" @change="handleCheckedChange1(index,$event)"><span>{{item.name}}</span></el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="isSubmitLoading" @click="postRole('formRole')">提  交</el-button>
                    <el-button @click="role=false">关  闭</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
          <pagination :size="listQuery.size" :total="pages.total" :current="listQuery.page" :pages="pages.pages" @pageChange="pageChange"/>
        </div>
    </div>
</template>

<script>
import pagination from '../../components/pagination'
import {mapState} from "vuex";
import {getSysrole,postSysrole,putSysrole,delSysRole} from "@/api";
import {splitTTimes} from '../../utils/dateFormat'
export default {
  name: "userRole",
  data () {
    return {
      role:false,
      imageURL: window.config.imageURL,
      splitTTimes,
      listQuery: {
        page: 1,
        size: 10
      },
      pages: {
        total: 0,
        pages: 0
      },
      isSubmitLoading: false,
      isSearchLoading: false,
      isRequestLoading: false,
      listData: [],
      powerFatherList:[
        {name:'水卡管理',id:'a'},
        {name:'水卡规格管理',id:'b'},
        {name:'订单管理',id:'c'},
        {name:'配送仓库管理',id:'d'},
        {name:'理赔管理',id:'e'},
        {name:'用户管理',id:'f'},
        {name:'常见问题管理',id:'g'},
        {name:'系统属性管理',id:'h'},
        {name:'管理员管理',id:'i'},
        {name:'角色设置',id:'j'},
      ],
      powerChlidList:[
        [
          {name:'京东仓配送',child:[{name:'搜索权限',id:'1'},{name:'批量新增',id:'2'},{name:'批量激活',id:'3'},{name:'批量导出',id:'4'},{name:'查看全量数据',id:'5'},{name:'查看自己数据',id:'6'},{name:'查看密码',id:'7'},{name:'查看销售类型',id:'9'},{name:'查看价格',id:'10'},{name:'删除',id:'8'}]},
          {name:'自有仓配送',child:[{name:'搜索权限',id:'1'},{name:'批量新增',id:'2'},{name:'批量激活',id:'3'},{name:'批量导出',id:'4'},{name:'查看全量数据',id:'5'},{name:'查看自己数据',id:'6'},{name:'查看密码',id:'7'},{name:'查看销售类型',id:'9'},{name:'查看价格',id:'10'},{name:'删除',id:'8'},{name:'确认送达',id:'11'}]},
        ],
        [{name:'创建水卡规格',id:'1'},{name:'删除',id:'2'}],
        [
          {name:'京东仓配送',child:[{name:'搜索权限',id:'1'},{name:'导出全部数据',id:'2'}]},
          {name:'自有仓配送',child:[{name:'搜索权限',id:'1'},{name:'导出全部数据',id:'2'},{name:'确认送达',id:'3'}]},
        ],
        [{name:'搜索权限',id:'1'},{name:'同步',id:'2'}],
        [{name:'搜索权限',id:'1'},{name:'查看全量数据',id:'2'},{name:'查看自己数据',id:'3'}],
        [{name:'搜索权限',id:'1'}],
        [{name:'搜索权限',id:'1'},{name:'新增',id:'2'},{name:'删除',id:'3'}],
        [],
        [{name:'新增',id:'1'},{name:'编辑',id:'2'},{name:'删除',id:'3'}],
        [{name:'新增',id:'1'},{name:'编辑',id:'2'},{name:'删除',id:'3'}]
      ],
      formRole:{
        roleName:'',
        roleMenu:{}
      },
      rules:{
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      },
      powerFatherChoose:[],
      powerChildChooseShow:0,
      powerChildChoose:[
        [[],[]],
        [],
        [[],[]],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      powerChildChooseList:[
        [['1','2','3','4','5','7','8','9','10'],['1','2','3','4','5','7','8','9','10','11']],
        ['1','2'],
        [['1','2'],['1','2','3']],
        ['1','2'],
        ['1','2'],
        ['1'],
        ['1','2','3'],
        [],
        ['1','2','3'],
        ['1','2','3'],
      ],
      powerChildNoChooseList:[
        [[],[]],
        [],
        [[],[]],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      checkAll:[[false,false],false,[false,false],false,false,false,false,false,false,false],
      isIndeterminate:[[false,false],false,[false,false],false,false,false,false,false,false,false],
      power:false,
      editId:-1,
    }
  },
  computed: {
    ...mapState({
      listKeepAlive: state => state.app.listKeepAlive,
    })
  },
  activated () {
    this.getList(this.listQuery)
  },
  created(){
    this.power = JSON.parse(localStorage.getItem('userRole')).power[9]
  },
  methods: {
    openEdit(val){
      this.editId = val.id
      this.formRole.roleName = val.roleName
      this.role = true
      this.powerChildChooseShow=0
      this.powerFatherChoose = val.roleMenu.page
      this.powerChildChoose = val.roleMenu.power
      this.powerChildChoose.forEach((i,key)=>{
        if (key == 0) {
          i.forEach((j,keys)=>{
            this.$set(this.checkAll[key],keys,j.length == this.powerChlidList[key][keys].child.length-1)
            this.$set(this.isIndeterminate[key],keys,j.length > 0 && j.length < this.powerChlidList[key][keys].child.length-1)
          })
        }else if (key == 2) {
          i.forEach((j,keys)=>{
            this.$set(this.checkAll[key],keys,j.length == this.powerChlidList[key][keys].child.length)
            this.$set(this.isIndeterminate[key],keys,j.length > 0 && j.length < this.powerChlidList[key][keys].child.length)
          })
        }else if (key == 4) {
          this.$set(this.checkAll,key,i.length == this.powerChlidList[key].length-1)
          this.$set(this.isIndeterminate,key,i.length > 0 && i.length < this.powerChlidList[key].length-1)
        } else {
          this.$set(this.checkAll,key,i.length == this.powerChlidList[key].length)
          this.$set(this.isIndeterminate,key,i.length > 0 && i.length < this.powerChlidList[key].length)
        }
      })
    },
    handleCheckedChange(fKey,key,val){
      if (this.powerChildChooseShow == 0) {
        let all = this.powerChildChoose[this.powerChildChooseShow][fKey].indexOf('5')
        let self = this.powerChildChoose[this.powerChildChooseShow][fKey].indexOf('6')
        if (key == 4 && val == true && self>=0) {
          this.powerChildChoose[this.powerChildChooseShow][fKey].splice(self,1)
        }
        if (key == 5 && val == true && all>=0) {
          this.powerChildChoose[this.powerChildChooseShow][fKey].splice(all,1)
        }
      }
    },
    handleCheckedChange1(key,val){
      if (this.powerChildChooseShow == 4) {
        let all = this.powerChildChoose[this.powerChildChooseShow].indexOf('2')
        let self = this.powerChildChoose[this.powerChildChooseShow].indexOf('3')
        if (key == 1 && val == true && self>=0) {
          this.powerChildChoose[this.powerChildChooseShow].splice(self,1)
        }
        if (key == 2 && val == true && all>=0) {
          this.powerChildChoose[this.powerChildChooseShow].splice(all,1)
        }
      }
    },
    handleCheckedCitiesChange(key){
      let checkedCount = 0
      let fid = this.powerFatherList[this.powerChildChooseShow].id
      if (key==0 || key==1) {
        checkedCount = this.powerChildChoose[this.powerChildChooseShow][key].length
        if (this.powerChildChooseShow==0) {
          this.$set(this.checkAll[this.powerChildChooseShow],key,checkedCount === this.powerChlidList[this.powerChildChooseShow][key].child.length-1)
          this.$set(this.isIndeterminate[this.powerChildChooseShow],key,checkedCount > 0 && checkedCount < this.powerChlidList[this.powerChildChooseShow][key].child.length-1)
        } else {
          this.$set(this.checkAll[this.powerChildChooseShow],key,checkedCount === this.powerChlidList[this.powerChildChooseShow][key].child.length)
          this.$set(this.isIndeterminate[this.powerChildChooseShow],key,checkedCount > 0 && checkedCount < this.powerChlidList[this.powerChildChooseShow][key].child.length)
          
        }
        if (this.powerChildChoose[this.powerChildChooseShow][0].length+this.powerChildChoose[this.powerChildChooseShow][1].length>0 && this.powerFatherChoose.indexOf(fid)<0) {
          this.powerFatherChoose.push(fid)
        } 
        if (this.powerChildChoose[this.powerChildChooseShow][0].length+this.powerChildChoose[this.powerChildChooseShow][1].length==0) {
          this.powerFatherChoose.splice(this.powerFatherChoose.indexOf(fid),1)
        }
      } else {
        checkedCount = this.powerChildChoose[this.powerChildChooseShow].length
        if (this.powerChildChooseShow==4) {
          this.$set(this.checkAll,this.powerChildChooseShow,checkedCount == this.powerChlidList[this.powerChildChooseShow].length-1)
          this.$set(this.isIndeterminate,this.powerChildChooseShow,checkedCount > 0 && checkedCount < this.powerChlidList[this.powerChildChooseShow].length-1)
        } else {
          this.$set(this.checkAll,this.powerChildChooseShow,checkedCount == this.powerChlidList[this.powerChildChooseShow].length)
          this.$set(this.isIndeterminate,this.powerChildChooseShow,checkedCount > 0 && checkedCount < this.powerChlidList[this.powerChildChooseShow].length)
        }
        if (this.powerChildChoose[this.powerChildChooseShow].length>0 && this.powerFatherChoose.indexOf(fid)<0) {
          this.powerFatherChoose.push(fid)
        } 
        if (this.powerChildChoose[this.powerChildChooseShow].length==0) {
          this.powerFatherChoose.splice(this.powerFatherChoose.indexOf(fid),1)
        }
      }
    },
    handleCheckAllChange(key){
      let fid = this.powerFatherList[this.powerChildChooseShow].id
      if (key==0 || key==1) {
        this.powerChildChoose[this.powerChildChooseShow][key] = this.checkAll[this.powerChildChooseShow][key]?JSON.parse(JSON.stringify(this.powerChildChooseList[this.powerChildChooseShow][key])):[]
        if (this.checkAll[this.powerChildChooseShow][key]) {
          this.$set(this.isIndeterminate[this.powerChildChooseShow],key,false)
          if (this.powerChildChoose[this.powerChildChooseShow][0].length+this.powerChildChoose[this.powerChildChooseShow][1].length>0 && this.powerFatherChoose.indexOf(fid)<0) {
            this.powerFatherChoose.push(fid)
          } 
        } else {
          
          if (this.powerChildChoose[this.powerChildChooseShow][0].length+this.powerChildChoose[this.powerChildChooseShow][1].length == 0 && this.powerFatherChoose.indexOf(fid)>=0) {
            this.powerFatherChoose.splice(this.powerFatherChoose.indexOf(fid),1)
          } 
        }
      } else {
        this.powerChildChoose[this.powerChildChooseShow] = this.checkAll[this.powerChildChooseShow]?this.powerChildChooseList[this.powerChildChooseShow]:[]
        if (this.checkAll[this.powerChildChooseShow]) {
          this.$set(this.isIndeterminate,this.powerChildChooseShow,false)
          this.powerFatherChoose.push(fid)
        } else {
          this.powerFatherChoose.splice(this.powerFatherChoose.indexOf(fid),1)
        }
      }
    },
    changePower(val,i){
      let key = this.powerFatherChoose.indexOf(val)
      if (key>=0) {
        this.$set(this.powerChildChoose,i,JSON.parse(JSON.stringify(this.powerChildChooseList[i])))
        if (val == 'a' || val == 'c') {
          this.$set(this.checkAll,i,[true,true])
          this.$set(this.isIndeterminate,i,[false,false])
        } else {
          this.$set(this.checkAll,i,true)
          this.$set(this.isIndeterminate,i,false)
        }
      } else {
        this.$set(this.powerChildChoose,i,this.powerChildNoChooseList[i])
        if (val == 'a' || val == 'c') {
          this.$set(this.checkAll,i,[false,false])
          this.$set(this.isIndeterminate,i,[false,false])
        } else {
          this.$set(this.checkAll,i,false)
          this.$set(this.isIndeterminate,i,false)
        }
      }
      this.toChangePFCheck(i)
    },
    toChangePFCheck(key) {
      this.powerChildChooseShow = key
    },
    delSysRole (id) {
      this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        delSysRole(id).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '角色删除成功',
              type: 'success',
              showClose: true,
            });
            this.getList()
          }
        })
      }).catch(() => {});
    },
    getList () {
      this.isRequestLoading = true
      getSysrole(this.listQuery).then(res => {
        this.isRequestLoading = false
        this.isSearchLoading = false
        if (res.code === 0) {
          this.isShow = true
          this.listData = res.data.records
          this.pages.total = res.data.total
          this.pages.pages = res.data.pages
        }
      }).catch(() => {
        this.isRequestLoading = false
        this.isSearchLoading = false
      })
    },
    toSearchList () {
      this.listQuery.page = 1;
      this.isSearchLoading = true;
      this.getList()
    },
    pageChange (e) {
      this.listQuery.page = e.current
      this.listQuery.size = e.size
      this.getList()
    },
    openAdd(){
      this.checkAll=[[false,false],false,[false,false],false,false,false,false,false,false,false]
      this.isIndeterminate=[[false,false],false,[false,false],false,false,false,false,false,false,false]
      this.powerFatherChoose=[]
      this.powerChildChooseShow=0
      this.powerChildChoose=[
        [[],[]],
        [],
        [[],[]],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      this.formRole = {
        roleName:'',
        roleMenu:{}
      }
      this.role=true
    },
    postRole(){
      if (!this.formRole.roleName) {
        return this.$message.error('请输入角色名')
      }
      if (this.powerFatherChoose.length == 0) {
        return this.$message.error('请选择模块')
      }
      this.$set(this.formRole.roleMenu,'page',this.powerFatherChoose)
      this.$set(this.formRole.roleMenu,'power',this.powerChildChoose)
      let request = null
      if (this.editId>=0) {
        this.$set(this.formRole,'id',this.editId)
        request = putSysrole({data:this.formRole})
      } else {
        request = postSysrole({data:this.formRole})
      }
      request.then((res)=>{
        console.log(res)
        if (res.code == 0) {
          if (this.editId>=0) {
            this.$message({
              message: '角色修改成功',
              type: 'success',
              showClose: true,
            });
          } else {
            this.$message({
              message: '角色设置成功',
              type: 'success',
              showClose: true,
            });
          }
          this.editId = -1
          this.getList()
          this.role = false
        }
      })
    },
    putSysrole(id){
      putSysrole(id).then(()=>{})
    },
  },
  components: {
    pagination
  }
}
</script>
<style lang="scss" scoped>
.picImg{
  max-width: 120px;
}
.vertical{
  display: flex;
  .title{
    font-weight: 600;
  }
}
.elgroup{
  display: flex;
  flex-direction: column;
}
.mr100{
  margin-right: 100px;
}
.mr40{
  margin-right: 30px;
}
/deep/.el-checkbox{
  .el-checkbox__label{
    line-height: 32px;
    width: 100%;
  }
}
</style>
